import { List, Avatar } from '@arkas/coreui';
import { INFO_DATE_FORMAT_WITH_TIME } from '@/helpers/dateTimeHelper';
import moment from 'moment';
import { NotificationDto } from '@emutabakat-types/mutabakat';
import React from 'react';

interface TaskProps {
  item: NotificationDto;
}

const Task: React.SFC<TaskProps> = props => {
  const { item } = props;
  return (
    <List.Item.Meta
      avatar={
        <Avatar icon="info" style={{ backgroundColor: 'rgb(117, 160, 221)' }} />
      }
      title={
        <div>
          <div>{item.mesaj}</div>
          {item.tarih && (
            <div className="from-now">
              <b>{moment(item.tarih).format(INFO_DATE_FORMAT_WITH_TIME)}</b>
            </div>
          )}
        </div>
      }
    />
  );
};

export default Task;
